import i18n from "i18next";
import { initReactI18next } from "react-i18next";

import fr from "locales/fr.json";
import ar from "locales/ar.json";
import en from "locales/en.json";

// Langues proposées dans le sélecteur
export const LANGUES = [
  { code: "fr", label: "Français", dir: "ltr" },
  { code: "ar", label: "العربية", dir: "rtl" },
  { code: "en", label: "English", dir: "ltr" },
];

const LANGUES_SUPPORTEES = ["fr", "ar", "en"];
const STORAGE_KEY = "lang";

function langueInitiale() {
  try {
    const saved = localStorage.getItem(STORAGE_KEY);
    if (LANGUES_SUPPORTEES.includes(saved)) return saved;
  } catch (e) {
    // localStorage indisponible (navigation privée...) : on garde le français
  }
  return "fr";
}

i18n.use(initReactI18next).init({
  // Copies : addResource() modifie l'objet en place, or RESSOURCES_JSON doit rester
  // la valeur d'origine (retour au JSON quand une surcharge est supprimée)
  resources: {
    fr: { translation: JSON.parse(JSON.stringify(fr)) },
    ar: { translation: JSON.parse(JSON.stringify(ar)) },
    en: { translation: JSON.parse(JSON.stringify(en)) },
  },
  lng: langueInitiale(),
  fallbackLng: "fr",
  supportedLngs: LANGUES_SUPPORTEES,
  interpolation: { escapeValue: false },
});

i18n.on("languageChanged", (lng) => {
  try {
    localStorage.setItem(STORAGE_KEY, lng);
  } catch (e) {
    // ignore
  }
});

export const directionDe = (lng) => (lng === "ar" ? "rtl" : "ltr");

// ── Surcharges de traductions (table "traductions", page admin /traductions) ──
// Les JSON ci-dessus restent la base ; la DB ne contient que les valeurs modifiées.
export const RESSOURCES_JSON = { fr, ar, en };

// Valeur d'origine (JSON) d'une clé pointée "menu.dashboard"
export function valeurJson(lng, cle) {
  return cle.split(".").reduce((o, k) => (o && typeof o === "object" ? o[k] : undefined), RESSOURCES_JSON[lng]);
}

// surcharges = { fr: {cle: valeur}, ar: {...}, en: {...} } ; valeur null = revenir au JSON
export function appliquerSurcharges(surcharges) {
  Object.entries(surcharges || {}).forEach(([lng, cles]) => {
    if (!LANGUES_SUPPORTEES.includes(lng)) return;
    Object.entries(cles || {}).forEach(([cle, valeur]) => {
      const finale = valeur ?? valeurJson(lng, cle);
      if (typeof finale === "string") i18n.addResource(lng, "translation", cle, finale);
    });
  });
  // Force le re-rendu des composants qui utilisent useTranslation()
  i18n.emit("languageChanged", i18n.language);
}

// Chargement au démarrage : en cas d'échec, l'app reste sur les JSON
fetch("/api/traductions/public")
  .then((r) => (r.ok ? r.json() : null))
  .then((data) => data && appliquerSurcharges(data))
  .catch(() => {});

export default i18n;
